module.exports = __webpack_public_path__ + "static/img/fbvtp.60ce30f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/fbvtp.png
// module id = BAGO
// module chunks = 1